import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<circle cx="16" cy="16" r="16" fill="#E1DDF6" key="0" />,<path fill="#2B2B2B" d="M23 8h-1V6h-2v2h-8V6h-2v2H9c-1.11 0-1.99.9-1.99 2L7 24c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 16H9V14h14zm0-12H9v-2h14zm-10 6h-2v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4h-2v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z" key="1" />,]
, 'DisplayCalendarMonthFilledx');
